import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import images from "../constants/images";
import Clickable from "../components/clickable.";
import Page from "../components/page";
import api from "../functions/api";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";

const Machines = () => {
    const [machine, setMachine] = useState();

    const user = useSelector((s) => s.user.value);

    const getMachine = async () => {
        try {
            const data = await api.get("/machines");
            setMachine(data);
        } catch (err) {
            console.log("🚀 ~ getMachine ~ err:", err);
        }
    };

    useEffect(() => {
        getMachine();
    }, []);

    return (
        <Page title="Machine">
            <div className="machine-1">
                {machine?.map((item, index) => {
                    item.admin = user;
                    const data = `https://embpass.com/attendance/${btoa(
                        JSON.stringify(item)
                    )}`;
                    const qr = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${data}&margin=10`;
                    const qrDownload = `${api.baseURL}/qr?size=600&data=${data}&text=${item?.nickName}`;
                    return (
                        <div className="style-0" key={index}>
                            <div className="num">{item?._id}</div>

                            <Link
                                to={`/machine-details/${btoa(
                                    JSON.stringify(item)
                                )}`}
                                className="style-1"
                            >
                                <img src={qr} className="style-4" />
                                <div className="style-6">
                                    <div className="style-7">
                                        {item?.nickName}
                                    </div>
                                    <div className="style-13">
                                        {item?.status == 1
                                            ? "ACTIVE"
                                            : "DEACTIVE"}
                                    </div>
                                </div>
                            </Link>

                            <Clickable onClick={() => window.open(data)}>
                                <img
                                    src={images.attendance}
                                    className="attendance-icon"
                                />
                            </Clickable>

                            <Clickable
                                onClick={() =>
                                    saveAs(qrDownload, item?.nickName)
                                }
                            >
                                <img src={images.download} className="btn" />
                            </Clickable>
                        </div>
                    );
                })}

                <Clickable to="/add-machine" className="style-15">
                    <img src={images.add} className="style-17" />
                </Clickable>
            </div>
        </Page>
    );
};

export default Machines;
